import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import { Avatar } from '@calendly/ui/components/avatar';
import { FlexLayout } from '@calendly/ui/components/flex-layout';
import { FullStoryExclude, FullStoryMask } from '@calendly/ui/components/fullstory-privacy';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useGetUserQuery } from 'common';
import { camelize } from 'services/string_utils';
import { getEventLimitsSummary } from 'shared/utils';
import { useEnabledHosts } from '../../../hooks';
const flexLayoutCenteredCss = "fdnspoq";
const FlexLayoutCentered = forwardRef((props, ref) => <FlexLayout ref={ref} {...props} className={classNames(flexLayoutCenteredCss, props.className)} />);
const HostSummary = ({
  membership
}) => <FlexLayoutCentered gap={8}>
    <FullStoryExclude>
      <Avatar size="x-small" src={membership.avatar_url} letter={membership.avatar_letter} alt={membership.name} />
    </FullStoryExclude>
    <div>
      <BodyText size="small" weight="bold">
        <FullStoryMask>
          {membership.name}
        </FullStoryMask>
      </BodyText>
      <BodyText size="small" color="muted">{getEventLimitsSummary(camelize(membership.user_event_limits))}</BodyText>
    </div>
  </FlexLayoutCentered>;
export const HostMeetingLimits = () => {
  const allEnabledHosts = useEnabledHosts();
  const {
    data: currentUser
  } = useGetUserQuery();
  const enabledHosts = allEnabledHosts?.filter(host => {
    const limits = host.user_event_limits;
    return limits && (limits.daily_limit || limits.weekly_limit || limits.monthly_limit);
  });
  if (!enabledHosts?.length) {
    return null;
  }
  const isSingleHost = enabledHosts.length === 1;
  const isCurrentUserHost = enabledHosts[0]?.user_id === currentUser?.id;
  let firstName = enabledHosts[0]?.name?.split(' ')[0];
  if (isCurrentUserHost) {
    firstName = firstName.concat(I18n.t('publisher.booking_modal.you'));
  }
  const summary = isSingleHost ? I18n.t('publisher.event_type_editor.sections.more_options.limits_and_buffers.host_meeting_limits.single_host', {
    name: firstName
  }) : HtmlParser(I18n.t('publisher.event_type_editor.sections.more_options.limits_and_buffers.host_meeting_limits.multiple_hosts'));
  return <FlexLayout direction="column" gap={4}>
      <BodyText size="medium">
        {I18n.t('publisher.availability.host_meeting_limits.title')}
      </BodyText>
      <BodyText size="small" color="muted">
        {summary}
      </BodyText>
      <FlexLayout gap={12} direction="column" spacingTop={4}>
        {enabledHosts.map(membership => <HostSummary key={membership.id} membership={membership} />)}
      </FlexLayout>
    </FlexLayout>;
};

require("./host_meeting_limits.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./host_meeting_limits.js");